import { List, ListItem, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface ISpecialServices {
  homeVisit: boolean;
}

export const SpecialServices = ({ homeVisit }: ISpecialServices) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  const listItemSx: SxProps = {
    p: '0 0 0 8px',
    '&::before': {
      content: '"\\2022"',
      fontSize: '20px',
      marginRight: '8px',
    },
  };

  return (
    <Stack gap='8px'>
      <Typography
        variant={isDesktop ? 'body2' : 'body1'}
        component='h4'
        sx={{
          cursor: 'text',
        }}
      >
        {dictionary.specialService}
      </Typography>
      <List sx={{ listStyleType: 'disc', listStylePosition: 'inside', p: 0 }}>
        {homeVisit && (
          <ListItem sx={{ ...listItemSx }}>
            <Typography
              variant='body3'
              sx={{
                cursor: 'text',
              }}
            >
              {dictionary.homeTherapy}
            </Typography>
          </ListItem>
        )}
      </List>
    </Stack>
  );
};
